import React from "react";
import { Comment } from "./Comment";

export const CommentList = ({ comments }) => {
  if (!comments) {
    return null;
  }
  return (
    <ul className="comments-list">
      {comments.map(comment => {
        return <Comment comment={comment} />
      })}
    </ul>
  )
}